import { useState, useEffect } from 'react';
import { useUserData } from '../hooks/useUserData';
import { ProxyApi } from '../api/rndApi';
import { SubscriptionCard } from './SubscriptionCard';
import { useTranslation } from 'react-i18next';

export const Subscriptions = () => {
  const { userData } = useUserData();
  const { t } = useTranslation();

  const [subscriptions, setSubscriptions] = useState([]);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [lifetimeAccessPurchased, setLifetimeAccessPurchased] = useState(false);

  useEffect(() => {
    (async () => {
      if (!userData || (!reload && !loading)) return;

      if (userData && !userData?.code) {
        setLoading(false);
        setShowError(true);

        return;
      }

      try {
        setShowError(false);
        const response = await ProxyApi.fetchClientSubscriptions(
          userData?.code
        );
        const leadData = await ProxyApi.fetchLead(userData?.code);

        setSubscriptions(response.subscriptions);
        leadData.client.orders.forEach((order) => {
          if (order.items.find((i) => i.product.key.includes('lifetime'))) {
            setLifetimeAccessPurchased(true);
          }
        });
      } catch {
        console.log('error');
        setShowError(true);
      } finally {
        setLoading(false);
        setReload(false);
      }
    })();
  }, [loading, userData, reload]);

  if (loading || showError) return null;

  return (
    <div style={{ marginTop: '40px' }}>
      <p style={{ marginBottom: '16px', fontSize: '12', fontWeight: 500 }}>
        {t('common.subscriptions')}
      </p>
      <div>
        {subscriptions.map((data) => (
          <SubscriptionCard
            key={data.id}
            data={data}
            setReload={setReload}
            lifetimeAccessPurchased={lifetimeAccessPurchased}
          />
        ))}
      </div>
    </div>
  );
};
